import { t } from 'i18next';

export enum KeyOperation {
  MAC_COMPUTATION = 'MAC_COMPUTATION',
  LOADED = 'LOADED',
  STORED = 'STORED',
  GENERATED = 'GENERATED',
  KEY_AGREEMENT = 'KEY_AGREEMENT',
  EXCHANGED = 'EXCHANGED',
  ENCRYPTION = 'ENCRYPTION',
  DECRYPTION = 'DECRYPTION',
  WRAPPING = 'WRAPPING',
  UNWRAPPING = 'UNWRAPPING',
  SIGNATURE = 'SIGNATURE',
  VERIFICATION = 'VERIFICATION',
  KEY_DERIVATION = 'KEY_DERIVATION',
  KEY_DEFINITION = 'KEY_DEFINITION',
  NO_OPERATION = 'NO_OPERATION',
}

export const getKeyRoleLabel = (role: KeyOperation): string => {
  return t(`keyProperties.operations.${role}`);
};
